import { render } from "./cookie_consent.vue?vue&type=template&id=7cc0c6a8"
import script from "./cookie_consent.vue?vue&type=script&lang=js"
export * from "./cookie_consent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__